// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ipf-menu-search {
  margin-right: var(--base-sizes-4);
  margin: 20px 15px 10px 16px;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Sidebar/Search/Search.css","webpack://./services/frontend/app/components/Sidebar/Search/Search.css"],"names":[],"mappings":"AADA;ECEE,iCAAiC;EACjC,2BAA2B;AAC7B","sourcesContent":[".ipf-menu-search {\n\n  margin-right: var(--base-sizes-4);\n\n  margin: 20px 15px 10px 16px\n}\n",".ipf-menu-search {\n  margin-right: var(--base-sizes-4);\n  margin: 20px 15px 10px 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
